import React from 'react';
import { Card, CardBody, CardTitle, Col } from 'reactstrap';

function CardArrecadacao({ listaDeArrecadacao, setTipoArrecadacao }) {

    const colorsCard = {
        "Registrado": "#3498db",
        "Cancelado": "#e74c3c",
        "Liquidado": "#2ecc71",
        "Vencido": "#f39c12",
    };
    
    return <>
        {listaDeArrecadacao?.map((value, key) => (
            <Col md={12} lg={3} key={key} className='mb-3 itemCardDefault' onClick={() => {
                if (value.listaFiscalizacaoInfratores.length == 0) {
                    setTipoArrecadacao({ status: value.status, listaFiscalizacaoInfratores: [] })
                } else {
                    setTipoArrecadacao(value);
                }
            }}>
                <Card
                    className="p-3 shadow rounded text-center text-white"
                    style={{
                        color: "#666",
                        cursor: "pointer",
                        border: "none",
                        backgroundColor: colorsCard[value.status]
                    }}
                >
                    <CardTitle tag="h6" className="mb-0 mb-2 d-flex justify-content-between align-items-center">
                        <span className='d-block fw-bold h5'> {value.status}</span>  <span className='d-block fw-bold h5'> {value.listaFiscalizacaoInfratores.length}</span>
                    </CardTitle>
                    <CardBody className="p-0  mb-0 h2">
                        {value?.listaFiscalizacaoInfratores.length > 0
                            ? "R$ " + value?.listaFiscalizacaoInfratores
                                .reduce((accumulator, currentValue) => accumulator + currentValue.valorMulta, 0)
                                .toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})
                            : "R$ 0,00"
                        }
                    </CardBody>
                </Card>
            </Col>
        ))}
    </>;
}

export default CardArrecadacao;